// Copyright (c) Move Closer 2022.

import { Component, Prop, Vue } from 'vue-property-decorator'

import { AddressData, AddressType } from '../../../contexts'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@Component<AddressDataMixin>({
  name: 'AddressDataMixin'
})
export class AddressDataMixin extends Vue {
  @Prop({ type: Array, required: false })
  public readonly address?: Array<AddressData>

  public addressType = AddressType

  public get addressSingle (): AddressData | undefined {
    if (!this.address) {
      return
    }

    return this.address[0]
  }

  public get hasAddresses (): boolean {
    if (!this.address) {
      return false
    }
    return this.address.length > 0
  }
}
